const options = {
  5: "bg-green-900/5",
  10: "bg-green-900/10",
  25: "bg-green-900/25",
  50: "bg-green-900/50",
  75: "bg-green-900/75",
  90: "bg-green-900/90",
  100: "bg-green-900",
};

const from = {
  5: "from-green-900/5",
  10: "from-green-900/10",
  25: "from-green-900/25",
  50: "from-green-900/50",
  75: "from-green-900/75",
  90: "from-green-900/90",
  100: "from-green-900",
};

export default function getBackgroundGreen900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
